<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      show-save-button
      unit="考勤设备"
      edit-title
      form-label-width="70px"
      id-key="DeviceId"
      :data="data"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="年级" prop="GradeSn">
          <el-input-number :min="1" :max="3" v-model="data.GradeSn"></el-input-number>
          <br v-if="isMB">
          <span class="tip">* 1：高一、2：高二、3：高三</span>
        </el-form-item>
        <el-form-item label="班级" prop="ClassSn">
          <el-input-number :min="1" :max="20" v-model="data.ClassSn"></el-input-number>
          <br v-if="isMB">
          <span class="tip">* 1：一班、2：二班、...... 20：二十班</span>
        </el-form-item>
        <el-form-item label="IP" prop="Ip">
          <el-input v-model="data.Ip" placeholder="请输入IP" :style="isMB?'width: 200px;':''"></el-input>
        </el-form-item>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        DeviceId: 0,
        Ip: "",
        GradeSn: 1,
        ClassSn: 1,
      },
      api: require("@/api/at/device").default,
      isMB: this.$store.state.isMB,
      rules: {
        Ip: [{ required: true, message: "IP称不能为空" }],
        GradeSn: [{ required: true, message: "年级不能为空" }],
        ClassSn: [{ required: true, message: "班级不能为空" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened(data) {},
    onEditOpened(data) {},
  },
};
</script>
<style scoped>
.tip {
  font-size: 12px;
  margin-left: 10px;
  color: #888888;
}
</style>